import logger from './logger';
import { loadClientConfig } from './config';
import { configureOidc } from './oidc';

function showServerUnavailable(error: unknown): void {
    logger.error('Could not load the client configuration', error);
    const root = document.getElementById('app');
    if (root) {
        root.textContent = "Mythic Table can't reach its server right now. Please try again in a moment.";
    }
}

export const ready = loadClientConfig()
    .then(async (config) => {
        configureOidc(config);
        const { start } = await import('./boot');
        start(config);
    })
    .catch(showServerUnavailable);
